export default __webpack_public_path__ + "static/media/Enzo.31faabf5.jpg";